export const en = {
    'allowed-page-id-is-not-number': 'the pageId value must be a positive integer. Errors in values: {values}',
    'allowed_page-ids-limit-reached': 'maximum number of forbidden pageIds: {limit}',
    and: 'and',
    'autobuget-campaign-name': 'Auto-budget campaign',
    'banned-domains-limit-reached': 'Maximum number of sites or ad exchanges: {limit}',
    'content-promotion-campaign-name': '"Content promotion" campaign',
    'empty-campaign-name': 'Campaign name is not specified',
    experiments: 'Experiments',
    'invalid-disabled-ips-number': 'Total number of blocked IP addresses can not exceed {maxIpsNumber}',
    'invalid-ips': 'Invalid IP addresses: {ips}',
    'key-goals': 'Priority goals',
    'max-length-name': 'Max length of the campaign name is {count} characters',
    'metrika-counters-is-unavailable': {
        one:
            "Can't link Yandex.Metrica tag {counters} to the campaign.  Either the tag has been deleted or you don't have access rights.",
        some:
            "Can't link Yandex.Metrica tags {counters} to the campaign. Either the tags have been deleted or you don't have access rights.",
        many:
            "Can't link Yandex.Metrica tags {counters} to the campaign. Either the tags have been deleted or you don't have access rights.",
        none:
            "Can't link Yandex.Metrica tags {counters} to the campaign. Either the tags have been deleted or you don't have access rights."
    },
    'name-campaign': '{campaignName} No. {count} of {date}',
    'price-package-campaign-name': 'todo',
    'required-field': 'Required field',
    'tgo-campaign-name': 'Text & Image campaign',
    'warning-about-metrika-counters':
        'When you delete the tags, you lose all settings {fields} for the applicable goals'
};
